import { render, staticRenderFns } from "./TableBlueLabelDescription.vue?vue&type=template&id=156b02a1&scoped=true&"
import script from "./TableBlueLabelDescription.vue?vue&type=script&lang=js&"
export * from "./TableBlueLabelDescription.vue?vue&type=script&lang=js&"
import style0 from "./TableBlueLabelDescription.vue?vue&type=style&index=0&id=156b02a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156b02a1",
  null
  
)

export default component.exports